import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'ud-ui/components/modal';
import { deleteTemplate } from 'modules/template-editor/store/templates/actions';
import { resetPressedState } from 'modules/template-editor/store/templates/templates';
import useTemplates from 'modules/template-editor/ui/hooks/use-templates';
import { useDispatchWithToast } from 'store/use-dispatch-with-toast';

function useDeleteModal() {
  const dispatch = useDispatch();
  const dispatchWithToast = useDispatchWithToast();
  const { activeTemplate, isProcessed, isFinished, currentProcess } = useTemplates();

  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onSubmit = useCallback(() => {
    if (!activeTemplate) return;
    dispatchWithToast(deleteTemplate({ id: activeTemplate.id }), { error: 'Не удалось удалить шаблон' });
  }, [activeTemplate, dispatchWithToast]);

  useEffect(() => {
    if (!isFinished) {
      return;
    }
    if (currentProcess !== 'delete template') {
      return;
    }
    close();
    dispatch(resetPressedState());
  }, [isFinished, close, dispatch, currentProcess]);

  return {
    modal: (
      <Modal.Confirm
        show={isOpen}
        title={activeTemplate?.name ? `Удалить шаблон «${activeTemplate.name}»?` : 'Удалить шаблон?'}
        description="Это действие необратимо."
        isLoading={isProcessed}
        onConfirm={onSubmit}
        onCancel={close}
      />
    ),
    close,
    open,
  };
}

export default useDeleteModal;
